import { articleContent } from '@/pages/article/page';
import { SITE_URL, SITE_NAME, FAVICON_URL } from './site';
import { getArticleImage } from './seoData';

function organization() {
  return {
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: { '@type': 'ImageObject', url: FAVICON_URL },
  };
}

export function getHomeJsonLd(): object {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      organization(),
      {
        '@type': 'WebSite',
        name: SITE_NAME,
        url: SITE_URL,
      },
    ],
  };
}

export function getArticleJsonLd(slug: string, pathname: string): object {
  const article = articleContent[slug];
  if (!article) return getHomeJsonLd();

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: article.h1,
        description: article.metaDesc,
        image: [getArticleImage(slug)],
        author: { '@type': 'Organization', name: SITE_NAME },
        publisher: organization(),
        datePublished: article.published,
        dateModified: article.updated,
        mainEntityOfPage: { '@type': 'WebPage', '@id': `${SITE_URL}${pathname}` },
      },
      {
        '@type': 'FAQPage',
        mainEntity: article.faq.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
    ],
  };
}